/* ACCORDIONS COLOR */
const productAccordions = document.querySelectorAll('.product .accordion');
productAccordions.forEach((accordion, index) => {
    if (index % 2 === 0) {
      accordion.style.backgroundColor = '#A2B3C033';
    }
});
/* ------------------------------------------------------------ */